import { render, staticRenderFns } from "./calibration.vue?vue&type=template&id=b3608de0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./calibration.vue?vue&type=style&index=0&id=b3608de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3608de0",
  null
  
)

export default component.exports